define('views/parts/menu/menu-action',[
    'underscore', 'backbone',
    // views
    'views/parts/menu/menu',
    'views/parts/form/select',
    'views/parts/menu/menu-context',
    // templates
    'text!templates/parts/menu/menu-action.html'
], function(
    _, Backbone,
    // views
    VMenu,
    VSelect,
    VMenuContext,
    // templates
    TMenuAction
) {

    /**
     * Encapsulates default options to create a VMenu with pills nav style.
     */
    var VMenuAction = VMenu.extend({
        className: "menu-actions nav nav-pills",
        initialize: function(opt) {
            this.options = opt || {};

            if (opt.moreActions) {
                this.initMoreActions();
            }

            VMenuAction.__super__.initialize.call(this, _.extend({
                template: TMenuAction
            }, opt));
        },

        render: function() {
            VMenuAction.__super__.render.apply(this, arguments);

            if (this.hasMoreActions()) {
                this.initMoreActions()
                    ._renderMoreActions();
            }
        },

        _renderMoreActions: function() {
            var menu = this.menu;
            menu.render();
            menu.$el.addClass('menu-options');
            this.$el.after(menu.el);
        },

        addMoreButton: function() {
            this.collection.unshift({ icon: 'fa fa-ellipsis-v', itemClass: "pull-right", callback: this.onMoreActionsClick, context: this, id: 'more-actions' });
        },

        removeMoreButton: function() {
            this.collection.shift();
        },

        hasMoreActions: function() {
            return this.options.moreActions;
        },

        addMoreActions: function(collection) {
            if (_.isArray(collection)) {
                collection = new Backbone.Collection(collection);
            }
            this.options.moreActions = collection;
            this.addMoreButton();
        },

        // Recreating the menu on every render willingly because ClickOutside element change
        initMoreActions: function() {
            this.addMoreButton();
            this.menu = new VMenuContext({
                collection: this.options.moreActions,
                context: this,
            });

            return this;
        },

        onMoreActionsClick: function() {
            this.menu.toggle();
        },

        onActionClick: function(e) {
            e.preventDefault();
        },

    });

    return VMenuAction;
});

